
import {Vue, Component} from 'vue-property-decorator';
import {userApi} from "@/api/organization";
import PasswordStrength from "@/components/PasswordStrength.vue";
import baseUrl, {imageUrl} from "../../constants";
import {mechanismApi} from "../../api/organization";

@Component({
  name: "RegistUserV2",
  components: {PasswordStrength}
})
export default class RegistUserV2 extends Vue {
  validateMobile = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error("请输入手机号"));
    } else {
      const mobile = this.loginData.phone;
      if(!mobile.match(/^1[3-9][0-9]{9}$/)){
        return callback(new Error('手机号格式不正确'))
      }else{
        callback();
      }
    }
  }
  baseUrl = baseUrl;
  imageUrl = imageUrl;
  active = 0;
  headers = {Authorization: ""};
  bizToken = "";
  registMsg = "";
  loginData = {
    phone: "",
    token: "",
    idCard: "",
    userName: "",
    idCardUP: "",
    code: "",
  };
  rules = {
    idCardUP: [
      {required: true, message: "请上传身份证头像面", trigger: "blur"},
    ],
    phone: [
      {required: true, message: "请输入手机号", trigger: "blur"},
      {validator: this.validateMobile, trigger: "blur"}
    ],
    code: [{required: true, message: "请输入手机验证码", trigger: "blur"}],
  };
  isSend = true;
  smsInterval = "点击获取验证码";
  isSubmit = false;
  private QRCode: any;
  getIdCardInfo(callback: any){
    userApi.getIdCardInfo(this.loginData.idCardUP, "CHANGE_MOBILE").then((r) => {
      if(r.data.result === 0){
        const {idNum, name} = r.data.data;
        this.loginData.idCard = idNum;
        this.loginData.userName = name;
        if(callback){
          callback();
        }
      }
    });
  }
  detectAuth(callback: any) {
    userApi.detectAuth(this.loginData.idCard,this.loginData.userName, this.loginData.idCardUP).then((r) => {
      if (r.data.result === 0) {
        const {bizToken, url} = r.data.data;
        this.bizToken = bizToken;
        if(callback){
          callback(url);
        }
      }
    });
  }
  //上传监控
  handleIdCardSuccess(res: any) {
    if (res.result === 0) {
      const rData = res.data;
      this.loginData.idCardUP = rData;
      this.$message.success("上传成功");
    }
  }

//上传头像监控
  beforeIdCardUpload(file: any) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    if (!isJPG && !isPNG) {
      this.$message.error('上传图片只能是 JPG 或 PNG格式!');
    }
    return (isJPG || isPNG);
  }

  logout() {
    // const win = window as any;
    // win.opener = null;
    // win.open("about:blank", "_top").close()
    this.goLogin();
  }

  checkMobile() {
    //验证手机号
    if (!this.isSend) return;
    let form = this.$refs.form as HTMLFormElement;
    form.validateField('phone', (phoneError: string) => {
      if(!phoneError){
        this.isSend = true
        this.sendSms();
      }
    });
  }

  //发送手机验证码
  sendSms() {
    if (!this.isSend) return;
      this.isSend = false;
      this.smsInterval = "发送中...";
      mechanismApi.sendVerifyCodeUnVerify({phone: '+86' + this.loginData.phone, template: "register"}).then((r) => {
        if (r.data.result === 0) {
          this.loginData.token = r.data.data
          this.smsIntervalMethod();
        }else{
          this.smsInterval = "获取验证码";
          this.isSend = true;
        }
      });
  }

  smsIntervalMethod() {
    let smsIntervalTime = 60;
    let timer = setInterval(() => {
      if (smsIntervalTime <= 1) {
        clearInterval(timer);
        this.smsInterval = "获取验证码";
        this.isSend = true; // 重新回复点击发送功能的条件
      } else {
        smsIntervalTime -= 1;
        this.smsInterval = `${smsIntervalTime}秒后再发`;
      }
    }, 1000);
  }

  nextStep() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if(valid){
        if(this.active === 0){
          this.getIdCardInfo(() => {
            this.detectAuth((url: string) => {
              this.active = 1;
              this.$nextTick(() => {
                new this.QRCode(document.getElementById("mobileImg"), {
                  width: 384,
                  height: 384,
                  text: url
                });
                this.queryResult();
              });
            });
          });
        }else if(this.active === 1){
          this.getDetectInfoEnhanced(() => {
            this.active = 2;
          });
        }else if(this.active === 2){
         userApi.changeUserMobile(this.loginData.idCard, this.loginData.phone, this.loginData.token, this.loginData.code).then((r: any) => {
           if(r.data.result === 0){
             this.active = 3;
             return;
           }
         });
        }
      }
    });
  }
  queryResult(){
    const timer = setInterval(() => {
      if(this.active != 1){
        clearInterval(timer);
      }
      userApi.getDetectInfoEnhanced(this.bizToken,"CHANGE_MOBILE", this.loginData.idCard, this.loginData.userName, "", this.loginData.phone, this.loginData.idCardUP, "").then((r) => {
        const {result, data} = r.data;
        if(result === 0){
          const {text} = data;
          if(text.comparemsg === "成功"){
            this.registMsg = text.comparemsg;
            this.active = 2;
            clearInterval(timer);
          }
        }
      });
    }, 5000);
    this.$once( 'hook:beforeDestroy' , () => { clearInterval(timer); });
  }

  getDetectInfoEnhanced(callback: any){
    userApi.getDetectInfoEnhanced(this.bizToken, "CHANGE_MOBILE", this.loginData.idCard, this.loginData.userName, "", this.loginData.phone, this.loginData.idCardUP, "").then((r) => {
      const {result, data, message} = r.data;
      if(result === 0){
        const {text} = data;
        if(text.comparemsg === "成功"){
          if(callback){
            callback();
          }
        }else{
          this.$message.warning(text.comparemsg);
          return;
        }
      }else{
        this.$message.warning(message);
        return;
      }
    });
  }

  goLogin(){
    this.$router.replace("/login");
  }
}
